import { createSlice } from "@reduxjs/toolkit";
import { FLASH_STATE } from "../constants/FlashConstants";

const initialState = {
    currentFlashState: FLASH_STATE.DISABLED,
};

const flashReducerSlice = createSlice({
    name: "flashReducer",
    initialState,
    reducers: {
        setFlashState(state, action) {
            state.currentFlashState = action.payload;
        },
        resetFlashReducer() {
            return initialState;
        },
    },
});

export const { setFlashState, resetFlashReducer } = flashReducerSlice.actions;
export default flashReducerSlice.reducer;
